import React, { Component } from 'react';

import '../../css/views/Home.css';
import ZigZag from '../../components/ZigZag';
import BlocCta from '../../components/BlocCta';
import Showcase from '../../components/Showcase';

import imageLogoArcaMetier from '../../images/logo-arca-metier.png';
import imageAgence from '../../images/agence.jpg';
import imageMethode from '../../images/methode.jpg';

import imageCommerce from '../../images/commerce.jpg';
import imageShopMe from '../../images/logo-white_shopme.png';

import imageCalendrier from '../../images/calendrier.jpg';
import imageBinaire from '../../images/binaire.jpg';
import imageCookies from '../../images/cookies.jpg';
import imageProjets from '../../images/projets.jpg';

class Home extends Component {
  render() {
    return (
    <div className="home">
        <section className="hero-unit">
            <div></div>
            <div className="slogan">
                <img src={imageLogoArcaMetier} alt="ARCA Computing" title="ARCA Computing - Agence de conseil et développement web" />
                <section className="bloc-texte">
                    <ZigZag />
                    <h2>Concepteurs de solutions intelligentes</h2>
                    <ZigZag />
                </section>
            </div>
            <div></div>
        </section>

        <section className="page-content">
            <section className="bloc-texte">
                <ZigZag />
                <h2>ARCA vous accompagne dans votre transformation numérique</h2>
                <ZigZag />
            </section>

            <section className="bloc-duo">
                <BlocCta
                    image={ {"src": imageAgence, "alt": "agence"} }
                    title={ "Concepteurs de solutions intelligentes" }
                    subtitle={ "ARCA est une agence de développement logiciel reconnue depuis 12 ans sur Bordeaux et Lyon." }
                    link={ {"href": "/agence", "label": "Découvrir les agences"} }
                 />
                <BlocCta
                    image={ {"src": imageMethode, "alt": "methode"} }
                    title={ "Notre méthode" }
                    subtitle={ "Agile et créatice de valeur ajoutée,<br />nous oeuvrons pour optimiser l'offre et<br />les performances des entreprises." }
                    link={ {"href": "/methode", "label": "Découvrir la méthode ARCA"} }
                 />
            </section>

            <section className="bloc-texte">
                <ZigZag />
                <h2>Une prise en charge numérique globale pour un projet réussi</h2>
                <ZigZag />
                <h3>Une passion pour le digital, une expertise technique, un regard créatif pour un projet réussi.</h3>
                <p>
                    Agence de conseil et de développement logiciel, ARCA Computing a su placer <strong>l'innovation</strong> au coeur de son approche. <strong>Prise en charge numérique globale</strong>, accompagnement et suivi personnalisé, flexibilité, font d'ARCA Computing une agence reconnue auprès de ses clients.
                </p>
            </section>

            <Showcase />

            <section className="bloc-texte">
                <ZigZag />
                <h2>Retail, parcours et relation client... Découvrez nos solutions clé en main !</h2>
                <ZigZag />
            </section>

            <section className="bloc-duo bloc-duo-2-1">
                <BlocCta
                    image={ {"src": imageCommerce, "alt": "commerce"} }
                    title={ "Connecter le commerce de demain !" }
                    subtitle={ "Vous êtes un professionnel du retail ? Un pôle stratégique dédié à la conception de solutions phygitales est à votre service." }
                    link={ {"href": "https://shopme-app.fr", "label": "Découvrir Shop.me"} }
                 />
                <div className="bloc bloc-cta bloc-gradient-shopme">
                    <img src={imageShopMe} alt="shopme" />
                </div>
            </section>

            <section className="bloc-texte contenu">
                <ZigZag />
                <h2>ARCA c'est aussi...</h2>
                <ZigZag />
            </section>

            <section className="bloc ligne extra">
                <div>
                    <img src={imageCalendrier} alt="calendrier" />
                    <p className="texteInfo">
                        <em>12</em> ans<br/>d'existence
                    </p>
                </div>
                <div>
                    <img src={imageBinaire} alt="binaire" />
                    <p className="texteInfo">
                        <em>5 723 753</em><br/>lignes de code
                    </p>
                </div>
                <div>
                    <img src={imageCookies} alt="cookies" />
                    <p className="texteInfo">
                        <em>3218</em> cookies<br/>avalés par l'équipe
                    </p>
                </div>
                <div>
                    <img src={imageProjets} alt="projet" />
                    <p className="texteInfo">
                        <em>100+</em> projets<br/>menés à bien
                    </p>
                </div>
            </section>
        </section>
    </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/home/Home.js